// api.js  
  
const BASE_URLS = {  
  telemetry: 'https://func-agrist-robot-information-realtime-time-telemetry.azurewebsites.net/api/realtime-telemetry-api',  
  image: 'https://func-agrist-robot-information-realtime-time-image.azurewebsites.net/api/robot-daily-data',  
  hourlyTelemetry: 'https://func-agrist-robot-information-hour-time.azurewebsites.net/api/robot-hour-data-api-telemetry',  

  dailyTelemetry: 'https://func-agrist-robot-information-daily-time.azurewebsites.net/api/robot-daily-telemetry',  
  // dailyTelemetry: 'https://func-robot-info-daily-time-v2.azurewebsites.net/api/robot-daily-telemetry',  

  weather: 'https://func-agrist-maps-api.azurewebsites.net/api/azure-maps-api/',  
  houseSituation: 'https://func-agrist-house-situation-api.azurewebsites.net/api/HouseSituationApi',  
  aiRecommendation: 'https://func-agrist-chatgpt4o-api.azurewebsites.net/api/ChatGpt4oApi',  
  marketAvg: 'https://func-agrist-wagri-market-price-avg-api.azurewebsites.net/api/wagri-market-price-avg-api',  
  geojson: 'https://func-agrist-wagri-geojson-api.azurewebsites.net/api/wagri-geojson-api',  
  joystick: 'https://app-agrist-azure-remote-backend-joystick-api.azurewebsites.net',  
  marketPrice: 'https://func-agrist-wagri-market-price-api.azurewebsites.net/api/wagri-market-price-api',  

  // yieldPrediction: 'https://func-agrist-yield-prediction-api.azurewebsites.net/api/yield-prediction-api',  
  yieldPrediction: 'https://app-agrist-ai-model-flask-bweua6cbhvdmczg3.japaneast-01.azurewebsites.net/Weekly_harvest_forecast',  

  // dailyYieldPrediction: 'https://func-agrist-yield-prediction-day-api.azurewebsites.net/api/yield-prediction-day-api',  
  dailyYieldPrediction: 'https://app-agrist-ai-model-flask-bweua6cbhvdmczg3.japaneast-01.azurewebsites.net/Daily_yield_forecast',  

  // marketForecast: 'https://func-agrist-market-forecast-day-api.azurewebsites.net/api/market-forecast-day-api'  
  // marketForecast: 'https://func-market-forecast-api-v2.azurewebsites.net/api/market-forecast-day-api'  
  marketForecast: 'https://app-agrist-ai-model-flask-bweua6cbhvdmczg3.japaneast-01.azurewebsites.net/Market_forecast'  
};  
  
const API_CODES = {  
  telemetry: 'JGadX3E1gFx4W0qgUb3Ux7hFjbFaL8sZCq9LxSDbcVyFAzFuKAgAxg==',  
  image: 'nq51jTOtCSKD9iNYFD2oqBXtWe_QvQUgUgdD49XI7WQdAzFuqzqCXg==',  
  hourlyTelemetry: 'p0t8z_rWziTrXNvbnGHuzWUd7rUwYz6AF1kG_JJSy1kcAzFu9bLkjg==',  

  dailyTelemetry: '4FKdovth11LSSZ8jt5HRNvEM97_XPDKNLypprah1mYtSAzFuEOfHJw==',  
  // dailyTelemetry: '1M-4rdqv1yfOjti-UoqX2qqMiVf6ZeRhMYOSP0fRUV4XAzFuxhfF8A==', 

  weather: 'De9zEwzhw5SkndoL_9EX17O6oJwyNJYILaBj9FeqArHLAzFuLTanyA==',  
  houseSituation: 'DNbr064lPD9C41BuldrknARDV_T4_XjSP0yZCoNk6gcjAzFus6Fw5Q==',  
  aiRecommendation: '-ZVnyoLdPo67XzHA0cRa874syJSvn6dlx7G_T9MGQgx3AzFu5-iYWw==',  
  marketAvg: '-5DQxEmECVctZusz-k0P8D0cVBUwwvfgW3r_ODUOVQ5GAzFuCDckTw==',  
  geojson: 'ZqLsN1W3EqNA36kh-1U-XwvZ2T2A4qaxZOxx4IYLV2iAAzFuZGnrYg==',  
  marketPrice: 'PBhbCkV6l0j7Kv-UtI-wSxUC16v4sysWmLrgPMc7Eh1IAzFusqsUyw==',  
  // yieldPrediction: 'UC4D7hmAttsYpDsu6GA9n6fQL2-kt1aoAgTOoyUPPttyAzFu2JgyEQ==',  
  // dailyYieldPrediction: 'YYg4SYjAMYqfS1_sn4CC0jwJ_UkFxpoPTW04_CId_1JwAzFuTpnUfQ==',  

  // marketForecast: 'JsZd9J5Lkae0t0YJux0nZ6vJVMkiSE3BT5fTDdCpxUI2AzFuQLIGmg=='  
  // marketForecast: '_Se6KtyLrNAcLN8h853pn61T48qoD683iXJr8RjAtOSdAzFuh-kl2g=='
};  

export const azureMapsApiKey = 'BHRmKXV1lgVJecklxVLfp8vMZ6TKJ36V650y9oRHFek4QPbvAuO5JQQJ99AGACYeBjF45srTAAAgAZMPWRCZ';  
export const azureFunctionsBaseUrl = 'https://func-agrist-wagri-geojson-api.azurewebsites.net';  
export const apiCode = 'ZqLsN1W3EqNA36kh-1U-XwvZ2T2A4qaxZOxx4IYLV2iAAzFuZGnrYg==';  
export const azureMapsScriptUrl = `https://atlas.microsoft.com/sdk/js/atlas.min.js?api-version=2&subscription-key=${azureMapsApiKey}`;  
export const API_URL = BASE_URLS.joystick;  
export const GOOGLE_DOCS_URL = 'https://docs.google.com/document/d/1rvTgU5nxXS58VH2B2KJhUNKFxGqIUiKS/edit?usp=sharing&ouid=116579326523714696978&rtpof=true&sd=true';  
  
  
const commonFetch = async (url, options = {}, errorMsg = 'HTTP error') => {  
  const response = await fetch(url, options);  
  if (!response.ok) {  
    throw new Error(`${errorMsg}! status: ${response.status}`);  
  }  
  return response.json();  
};  
  
export async function fetchNewtelemetry(machineId, records) {  
  const url = `${BASE_URLS.telemetry}?machine_id=${machineId}&records=${records}&code=${API_CODES.telemetry}`;  
  return commonFetch(url);  
}  
  
export async function fetchNewHarvestImage(machineId, limit) {  
  const url = `${BASE_URLS.image}?machine_id=${machineId}&limit=${limit}&code=${API_CODES.image}`;  
  return commonFetch(url);  
}  
  
export async function fetchOneHourTotalTelemetry(machineId, days) {  
  const url = `${BASE_URLS.hourlyTelemetry}?machine_id=${machineId}&days=${days}&code=${API_CODES.hourlyTelemetry}`;  
  return commonFetch(url);  
}  
  
export async function fetchDailyTotalTelemetry(machineId, days) {  
  const url = `${BASE_URLS.dailyTelemetry}?machine_id=${machineId}&days=${days}&code=${API_CODES.dailyTelemetry}`;  
  return commonFetch(url);  
}  
  
export async function fetchWeatherData(location, lat, lon) {  
  try {  
    let url = `${BASE_URLS.weather}?type=current&code=${API_CODES.weather}`;  
    url += lat && lon ? `&lat=${lat}&lon=${lon}` : `&location=${encodeURIComponent(location)}`;  
    return await commonFetch(url, {}, 'Error fetching weather data');  
  } catch (error) {  
    console.error(`Error fetching weather data for location ${location}:`, error);  
    return null;  
  }  
}  
  
export async function fetchHouseSituationApi(greenhouse) {  
  const url = `${BASE_URLS.houseSituation}?greenhouse=${greenhouse}&code=${API_CODES.houseSituation}`;  
  return commonFetch(url, {}, `Error fetching data for greenhouse ${greenhouse}`);  
}  
  
export async function fetchCurrentWeatherData(location, lat, lon) {  
  try {  
    let url = `${BASE_URLS.weather}?type=current&code=${API_CODES.weather}`;  
    url += lat && lon ? `&lat=${lat}&lon=${lon}` : `&location=${encodeURIComponent(location)}`;  
    return await commonFetch(url, {}, 'Error fetching weather data');  
  } catch (error) {  
    console.error(`Error fetching weather data for location ${location}:`, error);  
    return null;  
  }  
}  
  
export async function fetchForecastWeatherData(location, lat, lon) {  
  try {  
    let url = `${BASE_URLS.weather}?type=forecast&code=${API_CODES.weather}`;  
    url += lat && lon ? `&lat=${lat}&lon=${lon}` : `&location=${encodeURIComponent(location)}`;  
    return await commonFetch(url, {}, 'Error fetching weather data');  
  } catch (error) {  
    console.error(`Error fetching weather data for location ${location}:`, error);  
    return null;  
  }  
}  
  
export async function fetchHouseSituation(greenhouse) {  
  const url = `${BASE_URLS.houseSituation}?greenhouse=${greenhouse}&days=7&code=${API_CODES.houseSituation}`;  
  return commonFetch(url, {}, `Error fetching data for greenhouse ${greenhouse}`);  
}  

export async function fetchAIRecommendation(farmData, cropInformation, farmlocation) {  
  const url = `${BASE_URLS.aiRecommendation}?code=${API_CODES.aiRecommendation}`;  
    
  try {  
    const response = await fetch(url, {  
      method: 'POST',  
      headers: { 'Content-Type': 'application/json' },  
      body: JSON.stringify({ farmData, cropInformation, farmlocation })  
    });  
  
    if (!response.ok) {  
      throw new Error('Failed to fetch AI recommendation');  
    }  
    return response.text();  
  } catch (error) {  
    console.error('Error fetching AI recommendation:', error);  
    throw error;  
  }  
}  

export async function fetchMarketAvgData(itemName) {  
  const url = `${BASE_URLS.marketAvg}?itemName=${itemName}&months=12&code=${API_CODES.marketAvg}`;  
  return commonFetch(url, {}, 'Network response was not ok');  
}  
  
export async function fetchGeojsonData(number, abortSignal, cache) {  
  if (!number) throw new Error('Number is not defined');  
  if (cache.current[number]) {  
    return cache.current[number];  
  }  
  
  const url = `${azureFunctionsBaseUrl}/api/wagri-geojson-api?code=${apiCode}&fileName=field_polygon_${number}.json`;  
  const data = await commonFetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' }, signal: abortSignal });  
  
  if (data.targetFeatures && data.targetFeatures.length > 0) {  
    const allGeojsonFeatures = data.targetFeatures  
      .filter(feature => feature.geometry && feature.geometry.coordinates)  
      .map(feature => ({  
        type: "Feature",  
        geometry: {  
          type: "Polygon",  
          coordinates: feature.geometry.coordinates  
        },  
        properties: feature.properties || {}  
      }));  
  
    const geojsonFeatureCollection = { type: "FeatureCollection", features: allGeojsonFeatures };  
    const coordinatesList = allGeojsonFeatures.map(feature => feature.geometry.coordinates[0][0]);  
  
    if (coordinatesList.length > 0) {  
      const avgLat = coordinatesList.reduce((sum, coord) => sum + coord[1], 0) / coordinatesList.length;  
      const avgLon = coordinatesList.reduce((sum, coord) => sum + coord[0], 0) / coordinatesList.length;  
  
      cache.current[number] = { geojson: geojsonFeatureCollection, centerCoordinates: [avgLon, avgLat] };  
      return cache.current[number];  
    }  
  }  
  
  throw new Error('No target features found in the data');  
}  
  
export async function fetchWithRetry(url, options = {}, retries = 3, delay = 1000, abortSignal) {  
  for (let i = 0; i < retries; i++) {  
    try {  
      const response = await fetch(url, { ...options, signal: abortSignal });  
      if (!response.ok) {  
        throw new Error(`HTTP error! status: ${response.status}`);  
      }  
      return await response.json();  
    } catch (error) {  
      if (abortSignal.aborted) {  
        console.log('Fetch aborted');  
        return;  
      }  
      if (i === retries - 1) throw error;  
      await new Promise(resolve => setTimeout(resolve, delay));  
    }  
  }  
}  
  

export async function fetchRobotStatus(id) {  
  try {  
    const response = await fetch(`${API_URL}/status?hubName=command_hub_${id}`, { method: 'GET' });  
    return response.status === 404 ? 'オフ' : '稼働中';  
  } catch (error) {  
    console.error('Error fetching status:', error);  
    return 'サーバーエラー';  
  }  
}  
  
export async function fetchToken(hubName) {  
  const url = `${API_URL}/getToken?hubName=${hubName}`;  
  return commonFetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } }, 'HTTP error');  
}  
  
export async function forcedAgristAction(commandHubName) {  
  const url = `${API_URL}/forced_agrist`;  
  await commonFetch(url, {  
    method: 'POST',  
    headers: { 'Content-Type': 'application/json' },  
    body: JSON.stringify({ hubName: commandHubName })  
  }, 'HTTP error');  
}  
  
export const MARKET_PRICE_API_URL = `${BASE_URLS.marketPrice}?code=${API_CODES.marketPrice}`;  
export async function fetchMarketPriceData(itemName, months) {  
  const url = `${MARKET_PRICE_API_URL}&itemName=${itemName}&months=${months}`;  
  return commonFetch(url, {}, 'Network response was not ok');  
}  

// export async function fetchYieldPrediction(greenhouse, plantDate, inputDate, temp, humid, co2Level, weeks) {  
//   const url = `${BASE_URLS.yieldPrediction}?code=${API_CODES.yieldPrediction}`;  
//   return commonFetch(url, {  
//     method: 'POST',  
//     headers: { 'Content-Type': 'application/json' },  
//     body: JSON.stringify({ greenhouse_name: greenhouse, plant_date: plantDate, input_date: inputDate, temp, humid, co2: co2Level, weeks })  
//   }, 'Failed to fetch yield prediction');  
// }  

export async function fetchYieldPrediction(greenhouse, plantDate, inputDate, temp, humid, co2Level, weeks) {  
  const url = `${BASE_URLS.yieldPrediction}`;  
  return commonFetch(url, {  
    method: 'POST',  
    headers: { 'Content-Type': 'application/json' },  
    body: JSON.stringify({ greenhouse_name: greenhouse, plant_date: plantDate, input_date: inputDate, temp, humid, co2: co2Level, weeks })  
  }, 'Failed to fetch yield prediction');  
}  
  
// export async function fetchDailyYieldPrediction(greenhouse, plantDate, inputDate, temp, humid, co2Level, days, abortSignal) {  
//   const url = `${BASE_URLS.dailyYieldPrediction}?code=${API_CODES.dailyYieldPrediction}`;  
//   return commonFetch(url, {  
//     method: 'POST',  
//     headers: { 'Content-Type': 'application/json' },  
//     body: JSON.stringify({ greenhouse_name: greenhouse, plant_date: plantDate, input_date: inputDate, temp, humid, co2: co2Level, days }),  
//     signal: abortSignal  
//   }, 'Failed to fetch daily yield prediction');  
// }  

export async function fetchDailyYieldPrediction(greenhouse, plantDate, inputDate, temp, humid, co2Level, days, abortSignal) {  
  const url = `${BASE_URLS.dailyYieldPrediction}`;  
  return commonFetch(url, {  
    method: 'POST',  
    headers: { 'Content-Type': 'application/json' },  
    body: JSON.stringify({ greenhouse_name: greenhouse, plant_date: plantDate, input_date: inputDate, temp, humid, co2: co2Level, days }),  
    signal: abortSignal  
  }, 'Failed to fetch daily yield prediction');  
}  
  
// export async function fetchMarketforecast(date, days) {  
//   const url = `${BASE_URLS.marketForecast}?code=${API_CODES.marketForecast}`;  
//   return commonFetch(url, {  
//     method: 'POST',  
//     headers: { 'Content-Type': 'application/json' },  
//     body: JSON.stringify({ initial_date: date, days })  
//   }, 'Failed to fetch demand prediction');  
// }  

export async function fetchMarketforecast(date, days) {  
  const url = `${BASE_URLS.marketForecast}`;  
  return commonFetch(url, {  
    method: 'POST',  
    headers: { 'Content-Type': 'application/json' },  
    body: JSON.stringify({ initial_date: date, days })  
  }, 'Failed to fetch demand prediction');  
}  
  
export async function fetchSensorData(greenhouse) {  
  const url = `${BASE_URLS.houseSituation}?greenhouse=${greenhouse}&days=0&code=${API_CODES.houseSituation}`;  
  return commonFetch(url, {}, 'Failed to fetch sensor data');  
}  
  
export async function fetchLastYearMarketData(itemName, months) {  
  const url = `${BASE_URLS.marketAvg}?itemName=${itemName}&months=${months}&code=${API_CODES.marketAvg}`;  
  return commonFetch(url, {}, 'Network response was not ok');  
}  
